/**
 * Os rótulos do funil, palavra por palavra do admin atual. A ORDEM das chaves é parte do dado.
 *
 * Por que a ordem importa: o Kanban desenha uma coluna por chave de `STATUS_LEAD`, na ordem em que
 * elas aparecem (`admin.html:6582`), e "mover para trás" é decidido pela posição da chave nessa
 * mesma lista (`admin.html:7001-7003`). Reordenar uma linha aqui muda o quadro E a regra.
 *
 * Estes mapas também servem ao Financeiro, aos Clientes e à ficha, que mostram os mesmos rótulos.
 * Enquanto não sobem para `apps/admin/src/comum/` (pedido ao principal na entrega da frente A4),
 * moram aqui, e a Matriz os importa daqui.
 */

// As origens do lead (`admin.html:3052-3057`). A ordem das OPÇÕES no formulário é outra, e mora
// em `ORDEM_ORIGENS_NO_FORMULARIO`, porque o `<select>` do legado não segue este mapa.
export const ORIGENS_LEAD: Readonly<Record<string, string>> = Object.freeze({
  instagram: 'Instagram',
  indicacao: 'Por Indicação',
  site: 'Site',
  outro: 'Outra Rede Social ou Canal',
});

// A ordem das opções de "Origem" no novo lead (`admin.html:1816-1819`), com "Por Indicação"
// primeiro, e por isso escolhida ao abrir: é a primeira `<option>` do `<select>`.
export const ORDEM_ORIGENS_NO_FORMULARIO: readonly string[] = Object.freeze(['indicacao', 'instagram', 'site', 'outro']);

// As onze etapas do funil (`admin.html:3059-3071`), na ordem das colunas.
export const STATUS_LEAD: Readonly<Record<string, string>> = Object.freeze({
  novo: 'Novo',
  contatado: 'Contato realizado',
  diagnostico_agendado: 'Diagnóstico agendado',
  proposta_enviada: 'Proposta enviada',
  fechado: 'Fechado',
  com_juridico: 'Com jurídico',
  pagamento_a_receber: 'Pagamento a receber',
  pagamento_recebido: 'Pagamento recebido',
  em_consultoria: 'Em consultoria',
  finalizada: 'Finalizada',
  perdido: 'Perdido',
});

// As chaves na ordem, uma vez, para ninguém depender da ordem de `Object.keys` em outro lugar.
export const ORDEM_STATUS: readonly string[] = Object.freeze(Object.keys(STATUS_LEAD));

// Os oito produtos que se marcam num lead (`admin.html:3076-3085`). As chaves precisam bater com o
// CHECK de `leads_funil.produtos` no banco, como avisa o comentário do legado (`admin.html:3073-3075`).
export const PRODUTOS_LEAD: Readonly<Record<string, string>> = Object.freeze({
  eip: 'Estratégia de Imagem Pessoal e Profissional (EIP)',
  analise_proporcao_3d: 'Análise de Proporção Corporal 3D',
  coloracao_pessoal: 'Coloração Pessoal',
  montagem_looks: 'Montagem de Looks',
  mala_viagem: 'Mala de Viagem',
  personal_shopper: 'Personal Shopper',
  acompanhamento_anual: 'Acompanhamento Anual',
  projetos_sob_medida: 'Projetos Sob Medida',
});

// As etapas da jornada pós-venda, só para o texto do aviso "Jornada não concluída"
// (`admin.html:3089-3095`).
export const JORNADA_ETAPA_LABEL: Readonly<Record<string, string>> = Object.freeze({
  diagnostico_inicial: 'Diagnóstico Inicial',
  questionario: 'Questionário Geral',
  avaliando_material: 'Avaliando Material',
  em_atendimento: 'Em Atendimento',
  concluido: 'Concluído',
});
